import { WorkflowInfo } from '@selfai-platform/pipeline-common';
import { TreeNode } from 'primeng/api';
import { FunctionScope, Namespace } from '../models';

export class UserFunctionsControls {
  public static createScopeList(workflows: WorkflowInfo[], namespaces: Namespace[]): TreeNode[] {
    return [
      {
        key: '1',
        label: 'Workflows',
        icon: 'pi pi-fw pi-pencil',
        data: 'workflow',
        children: workflows.map((workflow) => {
          return {
            key: workflow.id,
            label: workflow.name,
            data: { scopeId: workflow.id, scopeType: 'workflow' },
          };
        }),
      },
      {
        key: '2',
        label: 'Namespaces',
        icon: 'pi pi-fw pi-pencil',
        data: 'namespace',
        children: namespaces.map((namespace) => {
          return {
            key: namespace.id,
            label: namespace.name,
            data: { scopeId: namespace.id, scopeType: 'namespace' },
          };
        }),
      },
    ] as TreeNode[];
  }

  public static mapScopesValuesToControl(scopes: FunctionScope[], scopeList: TreeNode[]): TreeNode[] {
    const controlScopes: TreeNode[] = [];
    scopes.forEach((scope) => {
      controlScopes.push(
        scopeList.find((list) => list.data === scope.scopeType).children.find((child) => child.key === scope.scopeId),
      );
    });
    return controlScopes;
  }
}
